<template>
  <b-modal
    id="addFilesModal1"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    :cancel-title="$t('general.close')"
    centered
    size="lg"
    no-close-on-backdrop
    :title="type == 'add' ? $t('adding_files') : $t('watch_files')"
    @ok="onSave()"
    @show="onShow()"
    :ok-disabled="!(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS && GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status && 
    GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name && GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name == 'new_requirement_brigades')"
  >
    <!-- @close="onCancel()"
    @cancel="onCancel()" -->
      <div>
        <div class="d-flex align-items-center" 
        v-if="(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS && GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status && GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name &&
         GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name == 'new_requirement_brigades')">
          <b-form-file
            v-model="file_upload"
            :browse-text="$t('general.select')"
            :placeholder="$t('select_a_file_or_drag_and_drop_it_here')"
            :drop-placeholder="$t('drag_file_here')"
            class="my-1"
          />

          <b-button @click="uploadFile" class="ml-1 d-flex" variant="primary" size="md">
            <feather-icon icon="UploadIcon" class="mr-25"/>
            {{$t('general.upload')}}
          </b-button>
        </div>
        
        <h6 class="font-weight-bold mt-1 mb-1">{{$t('file_table')}}</h6>
        <b-table
          :items="workFiles"
          :current-page="currentPage"
          :per-page="perPage"
          :fields="fields"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          stacked="md"
          small
          hover   
          bordered
          select-mode="single"
          selectable
          show-empty
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>
        
          <!-- @row-selected="onRowSelected" -->
          <!-- :filter="filter" -->

          <template #cell(id)="row">
              {{ (row.index + 1) + ((currentPage-1) * perPage) }} 
          </template>

          <template #cell(title)="row">
            {{ row.item.name }} 
          </template>

          <template #cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-button
                  v-if="checkAndHideDownloadFileIfNeeded(row.item)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  class="mr-50 mt-50 mb-50"
                  size="sm"
                  @click="downloadFile(row.item.url)"
                  >
                  <feather-icon
                      icon="DownloadIcon"
                      class="mr-50"
                  />
                  <span class="align-middle">{{$t('download')}}</span>
              </b-button>
            </div>
          </template>
        </b-table>

        <b-modal
          id="modal-before-delete-file"
          :ok-title="$t('yes')"
          :cancel-title="$t('no')"
          ok-variant="success"
          cancel-variant="danger"
          centered
          :title="$t('attention')"
          @ok="deleteFile"
        >
          <b-card-text>
            {{$t('are_you_sure_you_want_to_delete_this_file')}}
          </b-card-text>
        </b-modal>
      </div>


  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,

  BCard,
  BButton,
  BInputGroupPrepend, 
  BInputGroup, 
  BTable, 
  BBadge, 
  BPagination,
  BFormSelect,
  BFormFile,
  BCardText,
} from 'bootstrap-vue'
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  components: {
    BModal,
    BFormInput,
    BFormGroup,
    vSelect,
    BRow,
    ValidationObserver,
    ValidationProvider,
    BCol,

    BCardText,
    BButton,
    FeatherIcon,
    BFormFile,
    BPagination,
    BFormSelect,
    BInputGroupPrepend,
    BInputGroup,
    BCard,
    BTable,
    BBadge,
    ToastificationContent
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    type: {
      type: [String],
      default: false,
    },
  },
  data() {
    return {
      file_upload: null,
      delete_file_index: '',
      delete_file_item: '',
      fields: [
          {
              label: '№',
              key: 'id',
              class: 'text-center',
              tdClass: ['idClass']
          },
          {
              label: 'general.title',
              key: 'title',
              class: 'text-left',
              tdClass: ['fileClass']
          },
          {
              label: 'actions',
              key: 'actions',
              class: 'text-center',
              tdClass: ['actionsClass']
          },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  watch: {
   
  },
  computed: {
    ...mapGetters('agrements', ['GET_ONE_CONTRACT']),
    ...mapGetters("application", [
      "GET_ONE_APPLICATION_FOR_BRIGADE_WORKS",
    ]),






    // ========================= SETTERS_AND_GETTERS START =========================
    workFiles: {
      get: function () {
        return this.$store.state.application.workFiles;
      },
      set: function (newValue) {
        this.$store.commit('application/SET_WORK_FILES', newValue)
      }
    },
    // ========================= SETTERS_AND_GETTERS END =========================





  },
  async mounted() {
    
  },
  methods: {
    ...mapActions('application', [
      'UPDATE_PUT_APPLICATION_FOR_BRIGADE_WORKS',
      'FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS'
    ]),
    ...mapActions('taskManager', [
      'DELETE_ATTACHMENT_FILE'
    ]),





    // ========================= ON_SAVE START =========================
    async onSave() {
      this.cutNamesOfFiles()

      let formData = new FormData()
      this.workFiles.forEach((elem) => {
        if(typeof elem.url === 'object'){
          formData.append('files', elem.url)
        }
      })
      this.UPDATE_PUT_APPLICATION_FOR_BRIGADE_WORKS({
        data: formData,
        id: this.$route.params.id,
      })
      .then(async () => {
        await this.$parent.refresh()
        await this.onShow()
        this.$_okToast();
      })
      .catch((err) => {
        this.$_errToast(err);
      });
    },
    // ========================= ON_SAVE END =========================

 





    // ========================= ON_SHOW START =========================
    onShow(){
      if(this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.files){
        this.workFiles = this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.files
      }
      this.cutNamesOfFiles()
    },
    // ========================= ON_SHOW END =========================








    // ========================= OTHERS_SECTION START =========================
    cutNamesOfFiles(){
      if(this.workFiles){
        let array = []
        this.workFiles.forEach((elem, index) => {
          
          if(elem && !elem.url){
            array.push({url: elem})
          }else{
            array.push(elem)
          }
  
          if(array && array[index] && array[index].url && (typeof array[index].url == 'string')){
            if(array[index].url.includes('/')){
              array[index].name = array[index].url.substr(array[index].url.lastIndexOf('/') + 1);
            }else{
              array[index].name = array[index].url;
            }
          }
        })
        this.workFiles = array
      }
    },



    ...mapMutations('application', ['PUSH_WORK_FILES']),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    

    checkAndHideDownloadFileIfNeeded(item){
      if(item && item.url){
        return true
      }else{
        return false
      }
    },



    downloadFile(url) {
      fetch(url).then(function(t) {
        return t.blob().then((b)=>{
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          let fileName = url.substr(url.lastIndexOf('/') + 1);
          a.setAttribute("download", fileName);
          a.click();
        }
        );
      });
    },






    async deleteFile() {
      if(this.delete_file_item && this.delete_file_item.url){
        const resp = await this.DELETE_ATTACHMENT_FILE(this.delete_file_item.id);
        await this.FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS(this.$route.params.id).then(() => {
          const {
            invoice,
          } = this.GET_ONE_CONTRACT
  
          // this.invoiceItems = invoice
        })
        this.onShow()
  
        if(resp.status == 204) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              icon: "AlertCircleIcon",
              variant: "success",
              text: this.$t('files_successfully_deleted'),
            },
          });
        }
      }else{
        this.workFiles.splice(this.delete_file_index, 1)
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            icon: "AlertCircleIcon",
            variant: "success",
            text: this.$t('files_successfully_deleted'),
          },
        });
      }
    },


    choosedForDeletion(item, index){
      this.delete_file_item = item
      this.delete_file_index = index
    },






    async uploadFile() {
      if(this.file_upload){
        await this.PUSH_WORK_FILES(this.file_upload)
        this.totalRows = this.workFiles.length
      }
    },
    // ========================= OTHERS_SECTION END =========================










    
    
  },
}
</script>

<style>
.idClass{
  min-width: 50px !important;
  max-width: 100px !important;
}
.fileClass{
  min-width: 50px !important;
  max-width: 350px !important;
}
.actionsClass{
  min-width: 50px !important;
  max-width: 130px !important;
}
</style>
